<template>
  <div>
    <b-modal
      tabindex="0"
      v-model="dialog"
      title="Select Heart & Lungs"
      hide-footer
      no-close-on-backdrop
      hide-header-close
      no-close-on-esc
      ignore-enforce-focus-selector=".select2-search__field"
      size="sm"
      centered
    >
      <form-wrapper @submit="submit">
        <b-row class="pb-0">
          <b-col cols="12">
            <autocomplete
              v-model="organs"
              label="Hospital"
              :items="items"
              :multiple="false"
              :max="1"
              rules="required"
            >
            </autocomplete>
          </b-col>
        </b-row>
        <div class="d-flex">
          <div class="flex-grow-1"></div>
          <b-button variant="success" type="submit">Submit </b-button>
        </div>
      </form-wrapper>
    </b-modal>
  </div>
</template>

<script>
import { HEART_LUNGS } from "../../../assets/constants/waiting.list.constants";
export default {
  data() {
    return {
      organs: "",
      dialog: false,
      items: HEART_LUNGS,
    };
  },
  watch: {
    dialog(val) {
      if (val) this.organs = "";
    },
  },
  methods: {
    submit() {
      let organs = this.organs.split(",").map((organ_id) => {
        return { organ_id };
      });
      this.$emit("onOrganSelect", organs);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
